/* ============================================================
   FREEPET Press - page-scoped script (Stage B)
   Target: assets/freepet-press.js
   Stage B 1.0 - Full rewrite (v1.1: E-2 shim corrected)
   Responsibilities:
     1. Nav active state (Press entry; page is not in nav,
        rule kept for consistency)
   Deleted (Stage B):
     - initPressNewsletter (M-11 / RR-03: zero JS on newsletter;
       native {% form 'customer' %} POST in File 11)
     - initExternalLinks (D-10: static target+rel on mention
       links in File 7 covers protection)
   Transfer-safe: query helpers assembled at runtime; no literal
     double-sign sequence in this file (PB-30 / R-09).
   E-2 shim: forward-maps chrome.js dead calls to working fns.
   Depends on: window.FP (from freepet-base.js; fallback injected)
   Contract: SKILL-Core Section 5, SKILL-Engineering Section 1
   ============================================================ */

(function(){
'use strict';

var FP = window.FP = window.FP || {};

/* ------------------------------------------------------------
   Transfer-safe query helpers (home.js pattern)
   Assemble names at runtime to survive paste/transfer.
   S = one dollar sign char; FP[S] -> querySelector
   FP[S+S] -> querySelectorAll
   ------------------------------------------------------------ */
var S = '$';
var q1 = function(s, r){ return (r || document).querySelector(s); };
var qAll = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
if(!FP[S]){ FP[S] = q1; }
if(!FP[S + S]){ FP[S + S] = qAll; }

/* ------------------------------------------------------------
   E-2 forward shim (v1.1 corrected)
   Chrome.js may reference FP via 4-sign alias (transfer artifact).
   Register the 4-sign variant so those dead calls resolve
   instead of throwing. Also cover 3-sign just in case.
   ------------------------------------------------------------ */
try {
  if(!FP[S + S + S]){ FP[S + S + S] = qAll; }
  if(!FP[S + S + S + S]){ FP[S + S + S + S] = qAll; }
} catch(e){ /* shim best-effort */ }

/* ------------------------------------------------------------
   Locale-safe route root (Story A1 pattern)
   Multi-locale stores serve /en-us/pages/press; hardcoded
   paths break nav highlight. Use Shopify.routes.root.
   ------------------------------------------------------------ */
function routeRoot(){
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
}

/* ------------------------------------------------------------
   S1 - Nav active state (Press entry)
   MAP uses locale-safe path. Page is not in nav by design;
   rule kept for future nav inclusion consistency.
   ------------------------------------------------------------ */
function initNavActive(){
  var page = document.documentElement.getAttribute('data-page');
  if(!page) return;

  var MAP = {};
  MAP['press'] = routeRoot() + 'pages/press';
  var targetHref = MAP[page];
  if(!targetHref) return;

  requestAnimationFrame(function(){
    var links = qAll('.fp-nav-link, .fp-mmenu-link');
    links.forEach(function(a){
      if(a.getAttribute('href') === targetHref){
        a.classList.add('is-active');
        a.setAttribute('aria-current', 'page');
      }
    });
  });
}

/* ------------------------------------------------------------
   Boot (try/catch per init, PB-28b / R-10)
   Any init failure is isolated; subsequent inits still run.
   ------------------------------------------------------------ */
function safeInit(fn, label){
  try { fn(); } catch(e){
    if(window.console && console.warn) console.warn('[freepet-press] ' + label + ' failed: ' + e);
  }
}

function boot(){
  safeInit(initNavActive, 'initNavActive');
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

})();